window.renderHotelCalendar = function (dates) {
    $('#hotelCalendar').empty()
    const block = document.getElementById('hotelCalendar');
    const currentMonth = dates.month;
    const currentYear = dates.year;
    const dayNames = [
        translations.day_shortcuts.monday,
        translations.day_shortcuts.tuesday,
        translations.day_shortcuts.wednesday,
        translations.day_shortcuts.thursday,
        translations.day_shortcuts.friday,
        translations.day_shortcuts.saturday,
        translations.day_shortcuts.sunday
    ];

    // convert travels to array
    const travels = Object.values(dates.travels).map(obj => obj);

    const calendarTable = document.createElement("table");
    calendarTable.setAttribute('class', 'lowPriceCalendar')

    const weekDaysRow = calendarTable.insertRow();
    weekDaysRow.setAttribute('class', 'day-names')

    for (let i = 0; i < dayNames.length; i++) {
        weekDaysRow.insertCell().textContent = dayNames[i];
    }

    // Clear the calendar table body
    while (calendarTable.rows.length > 2) {
        calendarTable.deleteRow(2);
    }

    // Create a new date object for the first day of the month
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1);

    // Get the day of the week for the first day of the month (0-6)
    let firstDayOfWeek = firstDayOfMonth.getDay();

    // Adjust firstDayOfWeek to start from Monday (0-6)
    firstDayOfWeek = (firstDayOfWeek + 6) % 7;

    // Get the number of days in the current month
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    // Create the calendar cells
    let dayCount = 1;
    let nextMonthDay = 1;
    for (let i = 0; i < 6; i++) {
        if (dayCount > daysInMonth) {
            break;
        }

        const row = calendarTable.insertRow();
        row.setAttribute('class', 'date-row')

        for (let j = 0; j < 7; j++) {
            const cell = row.insertCell();

            if (i === 0 && j < firstDayOfWeek) {
                const daysInPreviousMonth = new Date(currentYear, currentMonth, 0).getDate();
                const previousMonthStart = daysInPreviousMonth - firstDayOfWeek + 1;
                cell.textContent = previousMonthStart + j;
                cell.setAttribute('class', 'disabled')
                continue;
            }

            if (dayCount > daysInMonth) {
                cell.textContent = nextMonthDay < 10 ? '0' + nextMonthDay : nextMonthDay;
                cell.setAttribute('class', 'disabled')
                nextMonthDay++;
                continue;
            }

            const travel = travels.find((travel) => travel.day === dayCount);

            if( travel ) {
                const link = document.createElement('a');
                const cost = document.createElement('p');
                link.textContent = dayCount < 10 ? '0' + dayCount : dayCount;
                link.href = travel.url;
                //link.target = '_blank';
                cost.textContent = `€ ${travel.price}`;
                link.setAttribute('class', 'travel-day');
                cost.setAttribute('class', 'travel-cost');
                link.appendChild(cost);
                cell.appendChild(link);

            } else {
                cell.textContent = dayCount < 10 ? '0' + dayCount : dayCount;
            }

            dayCount++;
        }
    }

    // Append the calendar table to the document body
    block.appendChild(calendarTable);
}

window.initCalendarLoader = function () {
    const calendarBlock = $('#hotelCalendar')
    $(calendarBlock).empty()
    $(calendarBlock).append(getLoaderBlock())
}

window.getHotelCalendarDates = function (areaId, month) {
    initCalendarLoader()
    return $.ajax({
        url: `${window.location.href}/calendar/${areaId}/${month}`,
        type: 'GET',
        dataType: 'json',
        data: {
            'searchData': searchData
        }
    })
}

window.initHotelCalendar = function () {
    disableSelects()
    const areaId = $('select[name=area_from]').val()
    const month = new Date(searchData.date_from.split('.').reverse().join('-')).getMonth() + 1;

    $('select[name=month] option').each(function() {
        if(parseInt($(this).val()) === parseInt(month)) {
            $(this).attr('selected', true);
        }
    })

    getHotelCalendarDates(areaId, month).done(function (data) {
        renderHotelCalendar(data)
        enableSelects()
        initHotelCalendarEventListeners()
    })
}

window.initHotelCalendarEventListeners = function () {
    $('#hotelCalendarSelects select').each(function() {
        $(this).on('change', function () {
            disableSelects()
            const areaId = $('select[name=area_from]').val()
            const month = $('select[name=month]').val()

            getHotelCalendarDates(areaId, month).done(function (data) {
                renderHotelCalendar(data)
                enableSelects()
            })
        })
    })
}

window.disableSelects = function () {
    $('#hotelCalendarSelects .custom-select').each(function() {
        $(this).css('pointer-events', 'none')
    })
}

window.enableSelects = function () {
    $('#hotelCalendarSelects .custom-select').each(function() {
        $(this).css('pointer-events', 'auto')
    })
}

$(function() {
    initHotelCalendar()
});
